<template>
  <div>
    <!-- Layout -->
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/tramite">Trámites</router-link></li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite } }">
                  Trámite N.° {{ idTramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ tipoTexto }}</li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 32px; cursor: pointer"
          @click="showModalHelp = true"
        >
          help
        </span>
      </div>
    </div>

<div class="card border-0 mb-3" style="background-color: #e8f4fd;">
  <div class="card-body py-2 px-3">
    <span class="text-dark fw-bold">{{ datosTramite }}</span>
  </div>
</div>
    <!-- Tabs con Bootstrap -->
    <ul class="nav nav-tabs mb-3" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'tramitePlanilla' }"
          @click="activeTab = 'tramitePlanilla'"
          type="button"
        >
          <span class="material-symbols-outlined">folder_open</span> Cabecera de atenciones
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'tramiteDetalle' }"
          @click="activeTab = 'tramiteDetalle'"
          type="button"
        >
          <span class="material-symbols-outlined">medical_services</span> Detalle de atenciones
        </button>
      </li>
<!--	  
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'planilla' }"
          @click="activeTab = 'planilla'"
          type="button"
        >
          <span class="material-symbols-outlined">list_alt</span> Atención médica
        </button>
      </li>	  
-->	  
    </ul>

    <!-- Contenido dinámico -->
    <div class="tab-content p-3 bg-white rounded shadow">
      <div v-if="activeTab === 'tramitePlanilla'">
        <ObservacionesPlanilla :idTramite="idTramite" :observacionTipo="observacionTipo" />
      </div>
      <div v-if="activeTab === 'tramiteDetalle'">
        <ObservacionesTramiteDetalle :idTramite="idTramite"  :observacionTipo="observacionTipo" />
      </div>
<!--	  
      <div v-else>
        <ObservacionesPlanillaDetalle :idPlanilla="idPlanilla" />
      </div>
-->	  
    </div>
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import ObservacionesPlanilla from "./ObservacionesPlanilla.vue";
//import ObservacionesPlanillaDetalle from "./ObservacionesPlanillaDetalle.vue";
import ObservacionesTramiteDetalle from "./ObservacionesTramiteDetalle.vue";

export default {
  name: "ObservacionesTramite",
  components: { Layout, ObservacionesPlanilla, ObservacionesTramiteDetalle },
  props: { p_idtramite: { type: String, required: true } },
  data() {
    return {
      activeTab: "tramitePlanilla",
      idTramite: Number(this.p_idtramite),
      observacionTipo: "M",
      idPlanilla: 14,
      mostrarInfo: true,
      showModalHelp: false,
      p_idPerfil: 0,
      datosTramite: "",
    };
  },
  computed: {
    tipoTexto() {
      if (this.observacionTipo === 'M') return "Observaciones de Auditoría Médica";
      if (this.observacionTipo === 'D') return "Observaciones de Gestión Documental";
      return "Desconocido";
    }
  },
  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.p_idPerfil = window.sessionStorage.getItem("idPerfil");
    if(this.p_idPerfil == 17)
      this.observacionTipo = "M";
    if(this.p_idPerfil == 19)
      this.observacionTipo = "D";
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },
  methods: {
    toggleInfo() {
      this.mostrarInfo = !this.mostrarInfo;
    },
  },
};
</script>

<style scoped>
.modal-content {
  background-color: #f9fafb;
}

.tab-content {
  border: 1px solid #dee2e6;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background-color: #e0f2fe;
  color: #0369a1;
  font-weight: bold;
  padding: 0.5rem;
  border: 1px solid #bae6fd;
}

td {
  padding: 0.5rem;
  border: 1px solid #e0f2fe;
}

tr:nth-child(even) {
  background-color: #f0f9ff;
}

tr:hover {
  background-color: #dbeafe;
}
</style>
